export default "__VITE_ASSET__DCavkAaf__"